/* ==============================================================================================
 * [ISIN] SEARCH RESULTS TABLE
 * ============================================================================================== */

var Sushi, CGS;

(function (Sushi, CGS) {
	"use strict";

	var apiEndpoint = "/json/isin/search.json";
	var tableElement = document.querySelector("#isinSearchResultsTable");

	if (!tableElement) {
		return;
	}

	CGS.table(tableElement, {
		ajax: apiEndpoint,
		columns: [
			{
				data: "isin",
				className: "c-table__cell",
			},
			{
				data: "isoIssuerName",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "isoIssueDescription",
				className: "c-table__cell",
			},
			{
				data: "currency",
				className: "c-table__cell",
			},
			{
				data: "interestRate",
				className: "c-table__cell",
			},
			{
				data: "maturityDate",
				className: "c-table__cell",
			},
		],
		columnDefs: [],
		initComplete: CGS.createRetractTableWrapper,
		dom: "<'top'>rt<'c-tableFooter'pi>",
	});

})(Sushi || (Sushi = {}), CGS || (CGS = {}));
